import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Data Gateway's `get<Schema>s` queries take native `where` / `order` / `paging` arguments
 * instead of a single JSON-string `input: DynamicQueryInput` — see graphql-query-builder.ts.
 * `order` is a `buildOrderLiteral` text; lookups send none.
 */
const buildListQuery = (
  alias: string,
  queryField: string,
  itemFields: string,
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order = '[]'
) => `
  query {
    ${alias}: ${queryField}(
      where: ${buildWhereLiteral(where)}
      order: ${order}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items { ${itemFields} }
    }
  }
`;

const CONDITIONAL_OFFER_FIELDS = `
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        FirstName
        LastName
        PhoneNumber
        Email
        Source
        YearsOfExperience
        Designation
        Comment
        HiringDepartmentId
        HiringDepartmentName
        InterviewPanelJson
        InternalReferralJson
        SourcePotentialProfileId
`;

/** Newest first by `CreatedDate` by default (new feature, no legacy list): the sort this list always used. */
export const DEFAULT_CONDITIONAL_OFFERS_ORDER: OrderBy[] = [
  { field: 'CreatedDate', direction: 'DESC' },
];

export const buildGetConditionalOffersQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_CONDITIONAL_OFFERS_ORDER
) =>
  buildListQuery(
    'ConditionalOffers',
    'getConditionalOffers',
    CONDITIONAL_OFFER_FIELDS,
    where,
    pageNo,
    pageSize,
    buildOrderLiteral(order)
  );

export const buildGetDepartmentsLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => buildListQuery('Departments', 'getDepartments', 'ItemId Title', where, pageNo, pageSize);

export const buildGetEmployeesLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) =>
  buildListQuery(
    'Employees',
    'getUserProfileDetails',
    'ItemId DisplayName Email',
    where,
    pageNo,
    pageSize
  );
